import Head from "next/head";
import { GetStaticProps } from "next/types";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "../components/Header";
import FloatLinks from "../components/FloatLinks";
import AboutKenzie from "../components/_faq/AboutKenzie";
import Course from "../components/_faq/Course";
import LaborMarket from "../components/_faq/LaborMarket";
import Payment from "../components/_faq/Payment";
import SelectiveProcess from "../components/_faq/SelectiveProcess";
import styles from "../styles/pages/faq.module.scss";

export default function FAQ() {
  useEffect(() => {
    AOS.init({
      disable: "mobile",
      duration: 700,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  return (
    <>
      <Head>
        <title>
          Dúvidas sobre curso de programação? Fale com a Kenzie Academy
        </title>
        <meta
          name="description"
          content="Tem dúvidas sobre o curso full stack, preços e formas de pagamento, processo seletivo e mercado de trabalho? Preparamos todas as respostas pra você."
        />
        <meta
          name="twitter:title"
          content="Dúvidas sobre curso de programação? Fale com a Kenzie Academy"
        />
        <meta
          name="twitter:description"
          content="Tem dúvidas sobre o curso full stack, preços e formas de pagamento, processo seletivo e mercado de trabalho? Preparamos todas as respostas pra você."
        />
        <meta
          property="og:title"
          content="Dúvidas sobre curso de programação? Fale com a Kenzie Academy"
        />
        <link rel="canonical" href="https://kenzie.com.br/faq" />
      </Head>

      <Header />

      <main>
        <section className={styles.wrapper}>
          <div className={styles.background}>
            <div className={styles.container}>
              <div data-aos="fade-right" className={styles.contentContainer}>
                <h1 className={styles.title}>Perguntas frequentes</h1>
                <p>
                  Ficou com alguma dúvida em algum tópico específico ou gostaria
                  de saber um pouco mais sobre a Kenzie?
                </p>
                <p>
                  Para ficar ainda mais fácil, organizamos pelos principais
                  temas.
                </p>
                <p>É só clicar e encontrar todas as respostas!</p>
              </div>
            </div>
          </div>
        </section>
        <section className="container">
          <AboutKenzie />
          <Course />
          <SelectiveProcess />
          <LaborMarket />
        </section>
      </main>
      <FloatLinks />
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
    revalidate: 60 * 60 * 24,
  };
};
